export default "<h1 class=\"page-title\">American</h1>\n<whiskey-list [whiskeyList]=\"whiskeyList\"></whiskey-list>";